export default __webpack_public_path__ + "img/component-menu.418bd949.png";